import React from 'react'
import PropTypes from 'prop-types'
import { hooks } from '@adc/ui-core'
import { BASE_DASHBOARD_PATH } from '../constants'
import NudgeTooltip from './nudgeTooltip'
import { nudgeKeys } from '..'

const PurchaseProfileNudge = ({ children, closeNudge, elmId, fade }) => {
  const isMobile = hooks.useIsMobileHook()
  const handleClose = () => {
    closeNudge(nudgeKeys.PURCHASE_PROFILE)
  }
  const handleSuccess = () => {
    window.location.assign(`${BASE_DASHBOARD_PATH}/purchase-profiles/`)
  }
  return (
    <NudgeTooltip
      fade={fade}
      elmId={elmId}
      children={children}
      showTooltip={!isMobile}
      handleClose={handleClose}
      handleSuccess={handleSuccess}
      content='Purchase profile remembers your information to save you time'
      header='Bidding on REO Bank Owned?'
      style='black'
    />
  )
}

PurchaseProfileNudge.propTypes = {
  children: PropTypes.node.isRequired,
  closeNudge: PropTypes.func,
  elmId: PropTypes.string,
  fade: PropTypes.bool,
}

PurchaseProfileNudge.defaultProps = {
  elmId: 'purchase_profile',
  fade: false,
}

export default PurchaseProfileNudge
